import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  selected: [],
  cleared: false,
  error: null,
};
export default reducerFactory(initialState, {
  [types.ADD_SELECTED_FILING_TYPES]: (state, action) => ({
    ...state,
    cleared: false,
    selected: action.response.filingTypes,
  }),
  [types.GET_FILING_TYPES_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_FILING_TYPES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    ...response.filingTypes,
  }),
  [types.GET_FILING_TYPES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.REMOVE_ALL_FILING_TYPES]: state => ({
    ...state,
    cleared: true,
    selected: [],
  }),
});
